'use client';

import type { PublicRecord } from '@/types/publicRecords';
import PublicTrustDocumentView from './PublicTrustDocumentView';

export default function PublicProofCardView({ record }: { record: PublicRecord }) {
  return <PublicTrustDocumentView record={record} kind="proof_summary" />;
}
